import { graphql } from "react-relay";

export const GeneratePromptFeedbackMutation = graphql`
  mutation GeneratePromptFeedbackMutation(
    $input: GeneratePromptFeedbackInput!
  ) {
    generatePromptFeedback(input: $input) {
      success {
        promptFeedback {
          id
          suggestions {
            name
            suggestedPrompt
            explanation
            isStale
          }
        }
      }
      error {
        message
      }
    }
  }
`;
